<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="landcover">4. Land Cover Trends</h2>
        <p>Use this section to better understand long term trends in land use and land cover. Data is available
          from several different datasets, each usually with a different spatial resolution or timeframe.
           By clicking a specific class (for example the "forest" class) you can 
          explore how much forest was lost, stable, and gained in the time period specified. It is also possible to see what the lost forest
          has turned into, and what types of other classes have changed into forest.
        </p>
        <LandCoverAnalysis 
          title="Land Cover Analysis" 
          attribution="Maps: Geofolio Landscape Reports." 
          v-bind:location="location" 
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded" 
           >
        </LandCoverAnalysis>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import LandCoverAnalysis from '@/components/factsheet/LandCoverAnalysis.vue'
    
    export default {
        name: 'LandCover',
        components: { LandCoverAnalysis },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
              
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>